import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import '@caios/ui/theme.css';
import '@caios/ui/controls.css';
import { ThemeProvider, ToastProvider, readTheme } from '@caios/ui';
import './app.css';
import { router } from './router.tsx';

// "See their portal": a tab opened at /portal-preview?account=… shows that client's portal, read-only. The account rides
// on every API call from this tab only (sessionStorage), and the server answers as that client's admin would see it.
const PREVIEW_KEY = 'caios.preview';
if (location.pathname === '/portal-preview') {
  const id = new URLSearchParams(location.search).get('account');
  if (id) sessionStorage.setItem(PREVIEW_KEY, id);
  history.replaceState(null, '', '/');
}
const previewing = sessionStorage.getItem(PREVIEW_KEY);
if (previewing) {
  const base = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    if (!new URL(url, location.href).pathname.startsWith('/api/v1/')) return base(input, init);
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    headers.set('x-caios-preview', previewing);
    return base(input, { ...init, headers });
  };
}

document.documentElement.dataset.theme = readTheme();   // before first paint: no flash of the wrong theme
const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
